<template>
  <b-card-code title="Modifier Année universitaire">
    <b-card-text>
      <span>Veuillez modifier les coordonnées de Année universitaire </span>
    </b-card-text>

    <!-- form -->
    <validation-observer
      v-if="departement"
      ref="simpleRules"
    >
      <b-form>
        <b-row>
          <b-col md="6">
            <b-form-group
              label="Nom"
              label-for="Nom"
            >
              <validation-provider
                #default="{ errors }"
                name="Nom"
                rules="required"
              >
                <b-form-input
                  v-model="departement.name"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Nom"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <h5>Etat département</h5>
              <b-form-checkbox
                v-model="departement.active"
                name="check-button"
                switch
                inline
                @click="departement.active = true"
              >
                Actif
              </b-form-checkbox>
            </b-form-group>

          </b-col>
          <b-col cols="12">
            <b-button
              variant="primary"
              type="submit"
              class="mb-1 mb-sm-0 mr-0 mr-sm-1"
              @click.prevent="editDepartement"
            >
              Modifier
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card-code>
</template>

<script>
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import BCardCode from '@core/components/b-card-code'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
/* import vSelect from 'vue-select' */
import {
  BFormInput,
  BFormGroup,
  BForm,
  BRow,
  BCol,
  BButton,
  BFormCheckbox,
  BCardText /*  */,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    BCardText,
    /* BFormTextarea, */
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormCheckbox,

  },
  data() {
    return {
      username: '',
      departement: {},
      required,

    }
  },
  created() {
    this.getDepartements()
  },
  methods: {
    async getDepartements() {
      this.load = 'true'
      const { id } = this.$route.params
      const response = await axios.get(`/api/departments/detail/${id}`)
      this.departement = response.data
      this.load = 'false'
    },
    async editDepartement() {
      this.$refs.simpleRules.validate().then(async success => {
        const { id } = this.$route.params
        if (success) {
          try {
            await axios
              .put(
                `/api/departments/update/${id}/`,
                {
                  name: this.departement.name,
                  active: this.departement.active,
                },
              )
            this.$router.push('/departements')
            setTimeout(() => {
              this.showToast('success', 'top-center', 'Departement Modifié avec succés')
            }, 1000)
          } catch (err) {
            setTimeout(() => {
              this.showToast('danger', 'top-center', err.toString())
            }, 1000)
          }
        }
      })
    },
    showToast(variant, position, text) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Notification',
            icon: 'InfoIcon',
            text,
            variant,
          },
        },
        {
          position,
        },
      )
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
